module.exports = __webpack_public_path__ + "img/icon_coupon.73a4cc31.svg";